export default {
  setSettings(state, payload) {
    state.settings = payload;
  }
};
